export default __webpack_public_path__ + "static/img_we_2-396fe9c947bdaba469bb5041dbfa8795.png";